var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "drug_info_block" },
    [
      _c(
        "div",
        { staticClass: "flex align-items-center" },
        [
          _c("div", { staticClass: "mr-2" }, [
            _c("span", {
              class: ["priority", "priority-" + _vm.drug.priority],
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-1 flex flex_gap_10" },
            [
              _vm.drug.cool
                ? _c("i", { staticClass: "icon icon-snowflake" })
                : _vm._e(),
              _vm._v(" "),
              _vm.drug.is_press_can
                ? _c("v-icon", {
                    staticClass: "red_icon",
                    attrs: { name: "spray-can" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.drug.title))]),
          _vm._v(" "),
          _c(
            "v-popover",
            {
              attrs: {
                placement: "right",
                trigger: "hover",
                delay: { show: 100, hide: 500 },
              },
            },
            [
              _c("span", { staticClass: "badge badge-info pointer" }, [
                _vm._v("ENG"),
              ]),
              _vm._v(" "),
              _c("template", { slot: "popover" }, [
                _c("div", [_vm._v(_vm._s(_vm.drug.en_title))]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.drug?.drug_relations ?? [], function (r) {
        return _vm._l(r?.tasks ?? [], function (t) {
          return _c("div", [_c("OutsorceCallTask", { attrs: { task: t } })], 1)
        })
      }),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "text-muted flex flex_gap_5" },
        [
          !_vm.inModal
            ? _c("i", {
                staticClass: "icon-fa icon-fa-edit openEditDrugIcon",
                on: {
                  click: function ($event) {
                    return _vm.openDrugEdit(_vm.drug.id)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.inModal
            ? [
                _vm._l(
                  [{ group: "managers_info" }, { group: "stores_info" }],
                  function (g) {
                    return [
                      _vm.hasDrugComment(_vm.drug, g.group)
                        ? _c(
                            "v-popover",
                            { attrs: { placement: "right", trigger: "hover" } },
                            [
                              _c("i", {
                                class: {
                                  "icon-fa icon-fa-comment":
                                    g.group === "managers_info",
                                  "icon-im icon-im-home":
                                    g.group === "stores_info",
                                  openEditDrugIcon: true,
                                  [_vm.hasDrugComment(
                                    _vm.drug,
                                    g.group,
                                    true
                                  )]: true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDrugEdit(_vm.drug.id)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("template", { slot: "popover" }, [
                                _c(
                                  "div",
                                  _vm._l(
                                    _vm.hasDrugComment(
                                      _vm.drug,
                                      g.group,
                                      false,
                                      true
                                    ),
                                    function (c) {
                                      return _c(
                                        "div",
                                        _vm._l(c.array_value, function (t) {
                                          return _c("div", [
                                            _c("p", [
                                              _vm._v(_vm._s(t.comment)),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    t.permanent
                                                      ? "бессрочно"
                                                      : t.valid_date
                                                  )
                                                ),
                                              ]
                                            ),
                                          ])
                                        }),
                                        0
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  }
                ),
              ]
            : _vm._e(),
          _vm._v("\n    " + _vm._s(_vm.drug.id) + "\n    "),
          +_vm.drug.pack_set !== 1
            ? _c(
                "span",
                { staticClass: "badge badge-info pack_set_block pull-right" },
                [
                  _vm._v("комплект: "),
                  _c("strong", { staticClass: "fs-18" }, [
                    _vm._v(_vm._s(Math.round(_vm.drug.pack_set))),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v("Страна: "),
        _c("strong", [_vm._v(_vm._s(_vm.getIncomeCountry()))]),
      ]),
      _vm._v(" "),
      _vm._l(
        _vm.drug.details.filter(
          (d) => d.group_alias === "extra" && d.alias === "country"
        ),
        function (detail) {
          return _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm.getCountryById(detail.int_value).name)),
            ]),
          ])
        }
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v("Основная валюта закупки: "),
        _c("strong", [
          _vm._v(
            _vm._s(
              (_vm.$AllCurrencies[_vm.drug.income_currency_id] &&
                _vm.$AllCurrencies[_vm.drug.income_currency_id].currency) ||
                "не найдено"
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex price_blocks" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "big_font flex flex_gap_10" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.getDrugCostPrice()))]),
              _vm._v(" "),
              _vm.drug.pack_set > 1
                ? _c("div", [
                    _c("strong", [
                      _vm._v(
                        "| " +
                          _vm._s(
                            Math.round(
                              _vm.getCostPriceByInvoices(_vm.invoices) *
                                _vm.drug.pack_set *
                                100
                            ) / 100
                          )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-popover",
                { attrs: { placement: "right" } },
                [
                  _c(
                    "span",
                    { staticClass: "badge badge-info pointer color-w" },
                    [_c("i", { staticClass: "icon-fa icon-fa-calculator" })]
                  ),
                  _vm._v(" "),
                  _c("template", { slot: "popover" }, [
                    _c("div", [
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.customCostPrice,
                              expression: "customCostPrice",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            placeholder: "Новая себестоимость",
                          },
                          domProps: { value: _vm.customCostPrice },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.customCostPrice = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.customCostPrice
                        ? _c("div", {
                            staticClass: "mt-1 p-1 fs-14",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getRecommendedPrice(
                                  true,
                                  _vm.customCostPrice,
                                  true,
                                  true
                                )
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                Math.round(
                  _vm.getCostPriceByInvoices(_vm.invoices) *
                    +_vm.profitCalculation.calculatedRate *
                    100
                ) / 100
              ) + "\n        руб."
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "v-popover",
                { attrs: { placement: "left", trigger: "hover" } },
                [
                  _c("span", { staticClass: "popover_span" }, [_vm._v("i")]),
                  _vm._v(" "),
                  _c("template", { slot: "popover" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.getRecommendedPrice(true)),
                      },
                    }),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("strong", [
                _vm._v(_vm._s(_vm.getRecommendedPrice()) + " руб."),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.displaySettings?.showIndPrice
          ? _c("div", { staticClass: "projected_price_block" }, [
              _c("p", { staticClass: "big_font" }, [
                _c("i", { staticClass: "icon-fa icon-fa-eur" }),
                _vm._v(" " + _vm._s(_vm.drug.projected_price)),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    Math.round(
                      +(
                        (_vm.profitCalculation &&
                          _vm.profitCalculation.calculatedRate) ||
                        0
                      ) * _vm.drug.projected_price
                    )
                  ) + " руб."
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.getRecommendedPrice(false, _vm.drug.projected_price)
                    ) + " руб."
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2" },
        [
          _vm.getDetailsByGroup("recipe", "no_use")
            ? _c("p", [
                _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v("По рецепту"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.getDetailsByGroup("egk"), function (c) {
            return _c("p", [
              _vm._v("ЕГК: "),
              _c("strong", [_vm._v(_vm._s(c.id))]),
              _vm._v(" "),
              c.invalid
                ? _c("span", { staticClass: "not_valid_code" }, [
                    _vm._v("не активный"),
                  ])
                : _vm._e(),
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.getDetailsByGroup("manufacturer"), function (c, i) {
            return [
              c.pzn
                ? _c(
                    "p",
                    [
                      _vm._v("PZN: "),
                      _c("strong", [_vm._v(_vm._s(c.pzn))]),
                      _vm._v(" "),
                      c.comment
                        ? _c("span", [_vm._v(_vm._s(c.comment))])
                        : _vm._e(),
                      _vm._v(" "),
                      i === 0
                        ? _c("LoadingButton", {
                            attrs: {
                              title: '<i class="icon-fa icon-fa-search"></i>',
                              loading: _vm.loading,
                              type: "button",
                              color: _vm.$constants.SUCCESS_COLOR,
                              onClick: () => _vm.parsePrice(c.pzn),
                              className: "btn btn-xs btn-outline-success ml-1",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.getDetailsByGroup("registration"), function (d) {
            return d.use
              ? _c(
                  "p",
                  [
                    _vm._v("\n      Регистрация:\n      "),
                    d.type === 0
                      ? [
                          _c("img", {
                            staticStyle: { width: "25px" },
                            attrs: { src: "/assets/icons/infinity.png" },
                          }),
                        ]
                      : [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.printDate(d.date, "DD.MM.YYYY"))),
                          ]),
                        ],
                  ],
                  2
                )
              : _vm._e()
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.drug.valid_dates && _vm.drug.valid_dates.length
        ? _c(
            "div",
            {
              class: {
                valid_dates_block: true,
                flex: _vm.smallValidDates,
                "flex-wrap": true,
              },
            },
            [
              _c("p", [_vm._v("Сроки годности:")]),
              _vm._v(" "),
              _vm._l(_vm.getSortedValidDates(), function (d) {
                return _c(
                  "p",
                  { key: d.id },
                  [
                    _c("i", {
                      staticClass: "icon-fa icon-fa-calendar-minus-o",
                    }),
                    _vm._v(" "),
                    !d.is_active && d.status === 1
                      ? [
                          _c("span", { staticClass: "badge badge-dark" }, [
                            _vm._v("удален"),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.printDate(d.expire_date, "MM.YYYY")) +
                        " "
                    ),
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(d.comment)),
                    ]),
                    _vm._v(" "),
                    d.status === 2
                      ? [_vm._m(1, true)]
                      : [
                          _c("LoadingButton", {
                            attrs: {
                              title: d.info_only
                                ? `<i class="icon-fa icon-fa-eye-slash"></i>`
                                : `<i class="icon-fa icon-fa-eye"></i>`,
                              className: "btn btn-default btn-xs",
                              onClick: () => _vm.updateExpireDate(d),
                              color: "gray",
                              loading: _vm.loadingBtns.updateExpire[d.id],
                            },
                          }),
                        ],
                    _vm._v(" "),
                    _vm.incomeExpDates[d.shortDate]
                      ? [
                          _c("span", { staticClass: "badge badge-info" }, [
                            _vm._v("поступление"),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "info_block mb-1" }, [
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            [
              +_vm.drug.pack_set !== 1
                ? _c("p", [_vm._v("Количество в зав.уп.")])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [_vm._v("Всего на складах:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex_gap_5 flex" },
                [
                  _c(
                    "v-popover",
                    {
                      attrs: {
                        popoverClass: "store_drug_popover",
                        popoverInnerClass: "store_drug_popover_inner",
                        "auto-hide": true,
                        placement: "right",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "badge badge-info pointer store_qty_badge",
                          on: { click: _vm.getStoreDetailsData },
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                Math.round(
                                  (_vm.storeDrugData?.total ?? 0) * 100
                                ) / 100
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "popover" },
                        [
                          _vm.storeDrugDetailsData.loading
                            ? [
                                _c("pulse-loader", {
                                  staticClass: "text-center",
                                  attrs: {
                                    loading: true,
                                    color: _vm.$constants.LOADING_COLOR,
                                  },
                                }),
                              ]
                            : [
                                _vm.storeDrugDetailsData.data
                                  ? _c("StoreTable", {
                                      attrs: {
                                        allowToGetMoves: true,
                                        hideStoreLink: true,
                                        disableCorrection: true,
                                        selectedDrugs: [_vm.drug],
                                        storeData:
                                          _vm.storeDrugDetailsData.data,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.storeDrugData && _vm.storeDrugData[30]
                    ? _c("span", [
                        _vm._v(
                          "(+РЦС " +
                            _vm._s(_vm.storeDrugData && _vm.storeDrugData[30]) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.freezeInvoices && Object.keys(_vm.freezeInvoices).length
                    ? [
                        _c("span", { staticClass: "freeze_details_block" }, [
                          _vm._v(
                            "(" +
                              _vm._s(
                                ((_vm.storeDrugData &&
                                  _vm.storeDrugData.total) ||
                                  0) - _vm.freezeInvoices.total_qty
                              ) +
                              " + " +
                              _vm._s(_vm.freezeInvoices.total_qty) +
                              "* "
                          ),
                          _c(
                            "strong",
                            {
                              class: {
                                red: +_vm.freezeInvoices.cost_diff > 0,
                                green: _vm.freezeInvoices.cost_diff < 0,
                              },
                            },
                            [
                              _vm._v("( "),
                              _c("i", { staticClass: "icon-fa icon-fa-eur" }),
                              _vm._v(
                                " " + _vm._s(_vm.freezeInvoices.cost_diff) + ")"
                              ),
                            ]
                          ),
                          _vm._v(")"),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v("M: "),
                _c("strong", [
                  _vm._v(
                    _vm._s((_vm.storeDrugData && _vm.storeDrugData[3]) || 0)
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-xs btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.openStoreTrends },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-line-chart" })]
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.getRequestedQty()) },
              }),
              _vm._v(" "),
              +_vm.drug.combined_type === 2 ? [_vm._m(2)] : _vm._e(),
              _vm._v(" "),
              +_vm.drug.combined_type === 1
                ? [
                    _vm._m(3),
                    _vm._v(" "),
                    _vm._l(_vm.drug.combined_drugs, function (cd) {
                      return _c("p", [
                        _vm._v(_vm._s(cd.drug.id) + " "),
                        _c("strong", [_vm._v(_vm._s(cd.drug.title))]),
                        _vm._v(
                          " ( x\n            " +
                            _vm._s(cd.rate) +
                            ")\n            "
                        ),
                        _c("span", { staticClass: "badge badge-info" }, [
                          _vm._v(
                            _vm._s(
                              (_vm.allStoreDrugsData &&
                                _vm.allStoreDrugsData[cd.combine_drug_id]
                                  ?.total) ??
                                0
                            )
                          ),
                        ]),
                        _vm._v(" M:\n            "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              (_vm.allStoreDrugsData &&
                                _vm.allStoreDrugsData[
                                  cd.combine_drug_id
                                ]?.[3]) ??
                                0
                            )
                          ),
                        ]),
                      ])
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.ordered && _vm.ordered.length
                ? _c("OrderedInvoices", {
                    attrs: {
                      orders: _vm.ordered,
                      costPriceCalculation: (costPrice) =>
                        _vm.getRecommendedPrice(true, costPrice, true, true),
                      costPrice: _vm.getCostPriceByInvoices(_vm.invoices),
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.allowToOrder
          ? _c(
              "div",
              { staticClass: "flex justify-content-between" },
              [
                _c(
                  "v-popover",
                  { attrs: { placement: "top", "auto-hide": true } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-xs border-r-0",
                        on: {
                          click: function ($event) {
                            return _vm.getSupplierPrices()
                          },
                        },
                      },
                      [_vm._v("\n          цены\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "template",
                      { slot: "popover" },
                      [
                        _c("pulse-loader", {
                          staticClass: "text-center",
                          attrs: {
                            loading: _vm.pricesLoading,
                            color: _vm.$constants.LOADING_COLOR,
                          },
                        }),
                        _vm._v(" "),
                        !_vm.pricesLoading && _vm.supplierPrices
                          ? [
                              !_vm.supplierPrices.success
                                ? _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.supplierPrices.message) +
                                        "\n            "
                                    ),
                                  ])
                                : _c("div", [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.supplierPrices.data.title)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Мин.цена: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.supplierPrices.data.min_price
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Средн.цена: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.supplierPrices.data.avage_price
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Кол.предложений: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.supplierPrices.data.offers_num
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.printDate(
                                            _vm.supplierPrices.data.date
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-xs",
                    attrs: { type: "button" },
                    on: { click: () => _vm.onOrderSelect(_vm.drug.id) },
                  },
                  [_vm._v("заказать\n      ")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("i", { staticClass: "icon-fa icon-fa-eur" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      { staticClass: "btn btn-success btn-xs", attrs: { disabled: "" } },
      [_c("i", { staticClass: "icon-fa icon-fa-clock-o" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("span", { staticClass: "badge badge-info" }, [
        _vm._v("Это компонент и не активен для продажи"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("span", { staticClass: "badge badge-info" }, [
        _vm._v("Препарат состоит из компонетов"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }